<template>
  <div class="content">
    <div class="title">
      <h2>卫计委要求：医疗机构一律停购大型医用设备</h2>
      <p>发布日期：2017-07-04</p>
    </div>
    <div class="text">
      <p>据江苏省宿迁市卫计委网站6月30日消息，由于大型医用设备配置审批已经由非行政许可审批事项调整为行政许可事项，根据该省卫计委的统一要求，自2017年6月22日起，宿迁市各类医疗机构一律停止购置大型医用设备，凡未经批准擅自购置的均视为违法购置。</p>
      <p>从字面意思上来理解，首先，"叫停"举措是江苏省的统一要求，而非仅宿迁一个市。其次，各类医疗机构都被"叫停"，，民营医院也应包括在内。这个动静可就不小了。</p>
      <p>另外，宿迁市卫计委网站消息并未明确，相关"叫停"措施要到何时终结。也许，会一直持续到大型医用设备的配置管理模式过渡期结束为止。</p>
      <p>大型设备配置许可办理，国家卫计委也喊停了</p>
      <p>实际上，由于国务院行政审批事项改革，"叫停"大型医疗设备购置的不仅仅只是江苏一省。</p>
      <p>今年1月，国家卫计委批复山西省卫计委《关于发放放射诊疗许可证有关问题的请示》时，就曾称，大型医用设备配置许可由非行政许可调整为行政许可，国家卫计委正在履行新设新设许可程序，按照国务院审改办相关要求，在此期间，暂停办理大型医用设备配置许可。</p>
      <p>国家卫计委的上述批复文件的精神，是对各个省份都适用的。</p>
      <p>只不过，在国家卫计委"叫停"时，《医疗器械监督管理条例》尚未进行新的修改。</p>
      <p>今年5月4日，国务院颁布第680号令，公布《国务院关于修改"医疗器械监督管理条例"的决定》，自公布之日起施行。</p>
      <p>修改后的《医疗器械监督管理条例》新增了几项内容，其中就包括：医疗机构配置大型医用设备须经省级以上卫计部门批准，并取得配置许可证；明确了医疗机构未经许可擅自配置使用大型设备的处罚细则。</p>
      <p>依据新版《医疗器械监督管理条例》，自6月22日起，在宿迁市、甚或江苏省违反"叫停"举措的医疗机构，轻者将被警告、没收违法所得、罚款1-5万元，重者将被罚款违法所得的5-10倍；严重者5年内将不得再配置任何大型医用设备。</p>
      <p>两个大型设备配置新规正在制定</p>
      <p>今年5月起修改的《医疗器械监督管理条例》还新增了一项重要内容，明确提出，大型医用设备配置管理办法由国务院卫计部门会同国务院有关部门制定；大型医用设备目录由卫计委商国务院有关部门提出，报国务院批准后执行。</p>
      <p>《医疗器械监督管理条例》是目前医疗器械行业的"母法"。随着其修改，有业内专家表示，国家主管部门下一步可能会对具体大型设备管理办法做出相应修改，甲类、乙类设备品目也有可能进行调整。</p>
      <p>宿迁市卫计委网站消息证实，国家卫计委正在会同有关部门制定《大型医用设备配置管理办法》和大型医用设备管理目录。</p>
      <p>而不管是甲乙类设备品目的变更，还是相关配置规定的修改，除了影响到医疗机构之外，也直接影响相关医疗设备厂商的经济利益</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabLargeEquipment'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  .title{
    h2{
      font-size: 20px;
      color: #000000;
      text-align: center;
      font-weight: 700;
      margin-top: 20px;
    }
    p{
      display: flex;
      justify-content: flex-end;
      font-size: 15px;
      color: #999999;
      padding-right: 20px;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
  .text{
    p{
      font-size: 18px;
      line-height: 36px;
      text-indent:40px;
    }
  }
}
</style>
